import * as THREE from 'three'
import { types } from 'mobx-state-tree'
import { Printedcircuitboard } from 'src/api/models/Content/Printedcircuitboard'
import { ContentEdgeProperties } from 'src/api/models/Content/ContentEdge/ContentEdgeProperties'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { contentEdge } from 'src/constants/typenames'
import { printedcircuitboardParameters, contentEdgeParameters } from 'src/constants/parameters'
import { IContentEdge } from './types'

export const ContentEdge: IContentEdge = generateNodeType(contentEdge)
  .props({
    node: types.optional(types.late(Printedcircuitboard), {
      properties: printedcircuitboardParameters.properties
    } as any),
    properties: types.optional(types.late(ContentEdgeProperties), contentEdgeParameters)
  })
  .views(self => {
    return {
      get boundings() {
        const width = self.node.properties.width.value
        const length = self.node.properties.length.value
        const thickness = self.node.properties.thickness.value
        const componentSideHeight = self.node.properties.componentSide.height.value
        const solderSideHeight = self.node.properties.solderSide.height.value
        const frontGap = self.properties.gap.front.value
        const topGap = self.properties.gap.top.value
        const rightGap = self.properties.gap.right.value
        const bottomGap = self.properties.gap.bottom.value
        const leftGap = self.properties.gap.left.value
        const backGap = self.properties.gap.back.value
        const size = {
          x: (length + leftGap + rightGap) / 2,
          y: (thickness + componentSideHeight + solderSideHeight + topGap + bottomGap) / 2,
          z: (width + frontGap + backGap) / 2
        }
        const offset = {
          x: (rightGap - leftGap) / 2,
          y: (topGap + componentSideHeight - bottomGap - solderSideHeight) / 2,
          z: (frontGap - backGap) / 2
        }
        const box3 = new THREE.Box3(
          new THREE.Vector3(-size.x + offset.x, -size.y + offset.y, -size.z + offset.z),
          new THREE.Vector3(size.x + offset.x, size.y + offset.y, size.z + offset.z)
        )
        return box3
      }
    }
  })
  .views(self => ({
    get size() {
      const size = new THREE.Vector3()
      self.boundings.getSize(size)
      return size
    }
  }))
